<template>

    <div class="vx-row">
        <div class="vx-col xl:w-1/3 w-full">
            <vx-card id="dataDiv"  class="vs-con-loading__container">
                <table class="simple-table">
                    <tr>
                        <td class="font-semibold">Name:</td>
                        <td>{{ node.name }}</td>
                    </tr>
                </table>

                <vs-divider/>

                <vs-button style="float: left" icon-pack="feather" icon="icon-edit" color="warning" class="mt-6; mr-3" @click="editPrompt = true">Edit</vs-button>
                <vs-button style="float: left" icon-pack="feather" icon="icon-trash-2" color="danger" class="mt-6; mr-3" @click="removeNode()">Remove</vs-button>
                <div style="clear: both"></div>
            </vx-card>
        </div>
        <div class="vx-col xl:w-2/3 w-full">
            <multicast-node-ports :node-id="Number($route.params.id)"/>
        </div>

        <vs-popup title="Edit Multicast Node" :active.sync="editPrompt">
            <div id="editNodeDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="editObject['name']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="saveNode">Save</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

    import MulticastNodePorts from './MulticastNodePorts'
    export default {
        components: { MulticastNodePorts },
        data() {
            return {

                node: {
                    id: 0,
                    name: ''
                },

                editPrompt: false,
                editObject: {}

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/multicast_node/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.node = response.data
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            saveNode() {
                this.$vs.loading({
                    container: '#editNodeDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const editPromise = this.$http.put('/api/management/v1/multicast_node/' + this.$route.params.id, {
                    name: this.editObject.name
                })

                editPromise.then(function() {
                    thisIns.editPrompt = false
                    thisIns.$printSuccess('Multicast node saved')
                    thisIns.$nextTick(() => {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#editNodeDiv > .con-vs-loading')
                })
            },
            removeNode() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.delete('/api/management/v1/multicast_node/' + this.$route.params.id)
                loadPromise.then(function() {
                    thisIns.$router.push('/multicast_nodes')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
<style lang="scss">
    #avatar-col {
        width: 10rem;
    }

    .simple-table {
        td {
            vertical-align: top;
            min-width: 170px;
            padding-bottom: .8rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }

</style>
